export const hex = (hex: string, alpha: number): string => {
  // Ensure alpha is between 0 and 1
  const clampedAlpha = Math.max(0, Math.min(1, alpha))

  // If alpha
  // is 0, return completely transparent
  if (clampedAlpha === 0) {
    return hex + '00'
  }

  // Calculate the alpha value
  const alphaValue = Math.round(255 * clampedAlpha)

  // Convert to hex and pad to 2 characters if needed
  const hexAlpha = alphaValue.toString(16).padStart(2, '0')

  return hex + hexAlpha
}

export const opacityFromHex = (hex: string) => {
  const nohash = hex.replace('#', '')
  if (nohash.length === 6) return 1
  return parseInt(nohash.slice(6, 8), 16) / 255
}
